import Drag from './index.vue';
export default Drag;
